// extracted by mini-css-extract-plugin
export default {"fixWidth":"Trunks_fixWidth__ycFLG","gridTitle":"Trunks_gridTitle__2o6u8"};